<template>
    <div class="home-banner" v-if="visible">
        <div class="home-banner-background" v-on:click="close()"></div>
        <div class="home-banner-modal">
            <img :src= "imgbase" alt="Banner">
            <button class="home-banner-close-button" title="Fechar" type="button" v-on:click="close()">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 348.333 348.334">
                    <path d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
                        c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
                        c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
                        l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
                        L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeBanner',
    data() {
        return {
            visible: false,
            bannerSize: "0",
            imgbase:'https://www.aldo.com.br/arquivos/home_banner_logado.jpg'
        };
    },
    async mounted() {
        const imageExists = await this.checkImageExists(this.imgbase);

        if (imageExists) {
            this.bannerSize = await this.getImageSize(this.imgbase);
            const storedSize = localStorage.getItem('homeBanner_size');

            if (this.bannerSize > 3000 && storedSize !== this.bannerSize) {
                this.visible = true;
            }
        }
    },
    methods: { 
        async checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                const img = new Image();                
                img.src = imageUrl;

                img.onload = () => resolve(true); 
                img.onerror = () => resolve(false); 
            });
        },      
        async getImageSize(imageUrl) {
            try {
                const response = await fetch(imageUrl, { method: 'HEAD' });
                if (response.status === 404) {
                    return "0";
                }
                return response.headers.get("content-length") || "0";
            } catch (error) {
                return "0";
            }
        },
        close() {
            localStorage.setItem('homeBanner_size', this.bannerSize);
            this.visible = false;
        }
    }
};
</script>

<style>
    .home-banner {
        position: fixed !important;
        z-index: 99998;
    }

    .home-banner .home-banner-background {
        position: inherit;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        display: block !important;
        background: #000000 !important;
        opacity: .6 !important;
    }

    .home-banner .home-banner-modal {
        position: inherit;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        width: auto;
        max-width: 80vw; 
        height:auto;
        max-height: 80vh;    
        border: 1px solid #BBBBBB;
        box-shadow: 0px 0px 8px #333;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .home-banner .home-banner-modal img {
        width: auto; 
        height: auto;
        max-width: 80vw; 
        max-height: 80vh; 
        display: block;
    }

    .home-banner .home-banner-close-button {
        position: absolute;
        top: 5px;
        right: 5px;
        border: none;
        background: transparent;
        cursor: pointer;
        width: 40px;
        height: 40px;
        color: white;
    }

        .home-banner .home-banner-close-button > svg {
            width: 20px;
            height: 20px;
            fill: #ffffff;
        }

        @media (max-width: 630px) {
    .home-banner .home-banner-modal {
        max-width: 80vw; 
        max-height: 80vh;
        width: auto;
        height: auto;
    }

    .home-banner .home-banner-modal img {
        max-width: 80vw;
        max-height: 80vh;
        width: auto;
        height: auto;
    }

        .home-banner .home-banner-close-button {
            width: 30px;
            height: 30px;
        }

            .home-banner .home-banner-close-button svg {
                width: 15px;
                height: 15px;
            }
    }
</style>